import { SystemEventLevel } from "../egencia-provider/index.js";
import * as uitoolkit from "../uitoolkit/index.js";
export const egenciaLoggerContext = {
  event: (systemEvent, ...args) => egenciaLoggerContext.log(SystemEventLevel.INFO, systemEvent.name, args),
  info: (message, ...args) => egenciaLoggerContext.log(SystemEventLevel.INFO, message, args),
  warning: (message, ...args) => egenciaLoggerContext.log(SystemEventLevel.WARN, message, args),
  error: (message, ...args) => egenciaLoggerContext.log(SystemEventLevel.ERROR, message, args),
  log: (level, message) => {
    uitoolkit.uitk.logger[level.toLowerCase()](message);
  }
};
